// If there are any oldRecords which don't exist in newRecords,
// append them to the newRecords array, but with only { id, _destroy: true } attributes.
// (so Rails will remove them)
export default function diff(newRecords, oldRecords = []) {
  const newRecordsIds = newRecords.map((newRecord) => newRecord.id);
  const recordsMarkedAsDestroy = oldRecords
    .filter((oldRecord) => newRecordsIds.indexOf(oldRecord.id) === -1)
    .map((oldRecord) => ({
      id: oldRecord.id,
      _destroy: true,
    }));

  return recordsMarkedAsDestroy.concat(newRecords);
}



// WEBPACK FOOTER //
// ./src/lib/utils/api/diff.js